
const initialState = {
    objectId:       "",
    eventTitle:     "",
    logoPicUrl:     "",
    inputs:         [],
    formLocked:     false,
    changesSaved:   false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case "GET_PLANNING_FORM_PENDING": {
            return {
                ...state,
                objectId:       "",
                eventTitle:     "",
                logoPicUrl:     "",
                inputs:         [],
                formLocked:     false,
            }
        }
        case "GET_PLANNING_FORM_FULFILLED": {
            return {
                ...state,
                objectId:   action.payload.data.objectId,
                eventTitle: action.payload.data.eventTitle,
                logoPicUrl: action.payload.data.logoPicUrl,
                inputs:     action.payload.data.inputs,
                formLocked: action.payload.data.formLocked,
            }
        }

        case "SET_PLANNING_FORM_INPUTS_FULFILLED": {
            return {
                ...state,
                inputs: action.payload.data.inputs,
                changesSaved: true
            }
        }

        case "SET_PLANNING_FORM_INPUTS_REJECTED": {
            return {
                ...state,
                changesSaved: false
            }
        }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/planningFormReducer.js